var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadGuage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    viewBox: "0, 0, 500, 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.685,365 C147.315,365 70.814,288.665 70.814,194.5 C70.814,100.336 147.315,24 241.685,24 C336.054,24 412.556,100.336 412.556,194.5 C412.556,288.665 336.054,365 241.685,365 z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.685,365 C147.315,365 70.814,288.665 70.814,194.5 C70.814,100.336 147.315,24 241.685,24 C336.054,24 412.556,100.336 412.556,194.5 C412.556,288.665 336.054,365 241.685,365 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.685,24 L241.685,365",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.534,192.742 L410.836,192.899",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.867,66.742 L362.534,323.409",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.534,74.075 L123.867,304.742",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.185,312.075 C176.135,312.075 123.401,259.469 123.401,194.575 C123.401,129.682 176.135,77.075 241.185,77.075 C306.236,77.075 358.97,129.682 358.97,194.575 C358.97,259.469 306.236,312.075 241.185,312.075 z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.685,192.742 L241.685,124.526",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.685,124.526 L241.685,76.526 L223.685,124.526 z",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "#000000",
    strokeWidth: 26,
    strokeOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M402.659,138.522 L426.825,289.982 L393.138,290.22 L386.68,367.357 L267.685,372.753",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.659,138.522 L426.825,289.982 L393.138,290.22 L386.68,367.357 L267.685,372.753",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.946,342.624 L395.613,138.522 L276.146,477.201 L118.901,406.167 L180.946,342.624 z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.946,342.624 L395.613,138.522 L276.146,477.201 L118.901,406.167 L180.946,342.624 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 35,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.185,220.575 C226.825,220.575 215.185,208.935 215.185,194.575 C215.185,180.216 226.825,168.575 241.185,168.575 C255.544,168.575 267.185,180.216 267.185,194.575 C267.185,208.935 255.544,220.575 241.185,220.575 z",
    fill: "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadGuage);
export default __webpack_public_path__ + "static/media/HeadGuage.dda4c9876e5cc1b974b8b5f0938b440b.svg";
export { ForwardRef as ReactComponent };